module.exports = __webpack_public_path__ + "img/好友.4db7581e.png";